import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const Projects = lazy(() => import("./pages/Projects"));
const Project = lazy(() => import("./pages/Project"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Skills = lazy(() => import("./pages/Skills"));

function App() {
  const handler = (e) => {
    e.preventDefault();
    fetch("http://localhost:3000/api/migrations/timer");
    e.returnValue = "";
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, []);
  return (
    <div>
      <div class="fixed inset-0 hidden lg:block">
        <div class="container relative h-full">
          <div class="absolute h-full border border-slate-50"></div>
          <div class="absolute h-full -ml-12 border border-slate-50"></div>
        </div>
      </div>
      <BrowserRouter>
        <Header />
        <Suspense>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/about" element={<About />} /> */}
            <Route path="/services" element={<Services />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects">
              <Route index element={<Projects />} />
              <Route path="/projects/:projectId" element={<Project />} />
            </Route>
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
